import { BloodType } from './general_models';
import { Entity, EntityStatus } from './entities.model';
import { RelationStatus } from './relations.model';
import { SportCategory } from './categories.model';
import {  DocumentTypes } from '../features/documents/models/document.models';


// tslint:disable: variable-name

export const FOOT_TYPES = [
  { id: 'R', name: 'Destro' },
  { id: 'L', name: 'Canhoto' },
  { id: 'B', name: 'Ambidestro' }
];

export class Athlete extends Entity {

  sport_id: number;
  weight: number;
  height: number;
  blood_type: BloodType;
  mobile_phone: string;
  residential_phone: string;
  current_uf: string;
  category?: SportCategory;
  // documents_ids?:DocumentTypes;
  rg?: string;
  old_ref?: string;
  field_position?: string;
  delegation_seq: number;


  constructor(o?: Partial<Athlete>) {
    super(o);
  }

  static categorize<T = Athlete | Athlete[]>(athletes: T, categories: SportCategory[], baseYear?: number): T {
    const _categories = categories.sort((a, b) => a.max < b.max ? -1 : 1);
    const _isArray = Array.isArray(athletes);
    const toUpdate: T[] = _isArray ? athletes as any : [athletes] as T[];

    const res = toUpdate.map(_a => {
      if (!_a || !(_a as any).birth) {
        return;
      }

      const _baseYear = baseYear || new Date().getFullYear();

      (_a as any).age = _baseYear - new Date((_a as any).birth).getFullYear();

      (_a as any).category = _categories.find((_c) => {
        const found = ((_a as any).age >= _c.min && (_a as any).age <= _c.max);
        return found;
      });

      return _a;
    });

    return (_isArray ? res : res[0]) as any;
  }

  static getCategory(athlete: Athlete, categories: SportCategory[], baseYear?: number): SportCategory {
    const _categories = categories.sort((a, b) => a.max < b.max ? -1 : 1);

    if (!athlete.birth) {
      return;
    }

    const _baseYear = baseYear || new Date().getFullYear();
    const age = _baseYear - new Date(athlete.birth).getFullYear();

    return _categories.find((_c) => {
      const found = (age >= _c.min && age <= _c.max);
      return found;
    });

  }

  defineCategory(categories: SportCategory[]) {
    this.category = Athlete.getCategory(this, categories);
  }

  yearAge(baseYear?: number) {
    return Entity.yearAge(this.birth, baseYear);
  }

  realAge() {
    return Entity.realAge(this.birth);
  }

}

// export class AthleteRelation extends Athlete {
//   status: any;

//   public static getStatusName(status: RelationStatus) {
//     const s = {
//       P: 'Pendente',
//       A: 'Aceito',
//       R: 'Rejeitado',
//       C: 'Cancelado'
//     };
//     return s[status];
//   }
// }
